import * as Graph from '../graph';
import * as Types from '../model/types';

// Warning: not projected
export const opIsNone = Graph.makeOp({
  name: 'isNone',
  argTypes: {
    val: Types.maybe('any' as const),
  },
  description: 'Determines if the value is None.',
  argDescriptions: {
    val: 'Possibly None value.',
  },
  returnValueDescription: 'True if the value is None.',
  returnType: inputTypes => 'boolean' as const,
  resolver: ({val}) => {
    if (Types.isConcreteTaggedValue(val)) {
      val = val._value;
    }
    return val == null;
  },
});
